// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1793732299181
      var cssReload = require("/var/tere_nodeweb/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  